export const CAREER__PERMISSIONS = {
  JOB_OFFERS: {
    MANAGE: {
      permissionGroupName: 'Zarządzanie ofertami pracy',
      NONE: {
        dbName: 'CAREER__JOB_OFFERS__MANAGE__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości zarządzania ofertami pracy na stronie marketingowej.'
      },
      ENABLED: {
        dbName: 'CAREER__JOB_OFFERS__MANAGE__ENABLED',
        name: 'Możliwość zarządzania ofertami pracy',
        description: 'Możliwość zarządzania ofertami pracy na stronie marketingowej.'
      }
    }
  }
} as const
